import BossSkip from './boss-skip/BossSkip';
import BossTimer from './boss-timer/BossTimer';
import Cheats from './cheats/Cheats';
import Enrage from './enrage/Enrage';
import Footer from './footer/Footer';
import Gold from './gold/Gold';
import Health from './health/Health';
import Modules from './modules/Modules';
import Selector from './selector/Selector';
import Stage from './stage/Stage';
import Energy from './energy/Energy';
import HardCurrency from './hard-currency/HardCurrency';
import SettingsModal from '../setting/SettingsModal';

export default class GUI extends Phaser.GameObjects.Container {
    private health!: Health;
    private gold!: Gold;
    private energy!: Energy;
    private hardCurrency!: HardCurrency;
    private footer!: Footer;
    private bossTimer!: BossTimer;
    private selector!: Selector;
    private modules!: Modules;
    private enrage!: Enrage;
    private cheats!: Cheats;
    private bossSkip!: BossSkip;
    public settings: SettingsModal;

    constructor(scene: Phaser.Scene) {
        super(scene, 0, 0);
        this.scene.layers.gui.add(this);

        this.setup();
    }

    setup() {
        this.health = new Health(this.scene);
        this.gold = new Gold(this.scene);
        // this.stage = new Stage(this.scene);
        this.energy = new Energy(this.scene);
        this.settings = new SettingsModal(this.scene);

        const webAppVersion = parseInt(window.Telegram.WebApp.version);
        if (webAppVersion >= 8) window.Telegram.WebApp.SettingsButton.onClick(() => {
            this.settings.show()
        });

        this.hardCurrency = new HardCurrency(this.scene);
        this.footer = new Footer(this.scene);
        this.bossTimer = new BossTimer(this.scene);
        this.selector = new Selector(this.scene);
        this.modules = new Modules(this.scene);
        this.enrage = new Enrage(this.scene);
        this.cheats = new Cheats(this.scene);
        this.bossSkip = new BossSkip(this.scene);
        this.bossSkip.setPosition(this.scene.cameras.main.centerX, this.hardCurrency.y + 200);
        this.bossTimer.setPosition(this.scene.cameras.main.centerX, this.hardCurrency.y + 130);

        this.add([
            this.health,
            this.gold,
            this.settings.button,
            // this.stage,
            this.energy,
            this.hardCurrency,
            this.footer,
            this.bossTimer,
            this.selector,
            this.modules,
            // this.enrage,
            // this.cheats,
            this.bossSkip,
        ]);
    }
}
